import { __read } from "tslib";
export var baseOnlyUniqueUrlValidator = function (pathPrefixes) {
    return function (value, defaultMapping) {
        var segments = value.split('/');
        var isDefaultMapping = value === defaultMapping;
        if (segments.length < 1 || isDefaultMapping) {
            return true;
        }
        var defaultSegments = defaultMapping.split('/');
        var _a = __read(defaultSegments, 1), defaultPrefix = _a[0];
        var _b = __read(segments, 1), firstSegment = _b[0];
        var result = pathPrefixes.every(function (pathPrefix) {
            return pathPrefix === defaultPrefix ? true : pathPrefix !== firstSegment;
        });
        return result;
    };
};
//# sourceMappingURL=utils.js.map